export default "__VITE_ASSET__CAFxCd7q__"